<ng-template #toolbar>
  <span class="ql-formats">
    <select class="ql-header">
      <option value="1"></option>
      <option value="2"></option>
      <option selected></option>
    </select>
  </span>
  <span class="ql-formats">
    <button
      [attr.aria-label]="'checklistItem.toolbar.bold' | translate"
      type="button"
      class="ql-bold"></button>
    <button
      [attr.aria-label]="'checklistItem.toolbar.italic' | translate"
      type="button"
      class="ql-italic"></button>
    <button
      [attr.aria-label]="'checklistItem.toolbar.underline' | translate"
      type="button"
      class="ql-underline"></button>
  </span>
  <span class="ql-formats">
    <button
      [attr.aria-label]="'checklistItem.toolbar.orderedList' | translate"
      class="ql-list"
      value="ordered"
      type="button"></button>
    <button
      [attr.aria-label]="'checklistItem.toolbar.unorderedList' | translate"
      class="ql-list"
      value="bullet"
      type="button"></button>
  </span>
  <span class="ql-formats">
    <select class="ql-align">
      <option selected></option>
      <option value="center">{{ 'checklistItem.alignment.center' | translate }}</option>
      <option value="right">{{ 'checklistItem.alignment.right' | translate }}</option>
    </select>
  </span>
</ng-template>
